import React from "react";
import GenericDashboard from "../GenericDashboard/GenericDashboard.js";
import APIService from "../../Service/APIService.js";
import SectionHeader from "../../common/section-header/index.js";
import ManufacturerUserAddAction from "./ManufacturerUserAddAction.js";

const ManufacturerUsers = (props) => {
  const { manufacturerData, canAddUser = false } = props;
  const [formattedUsers, setFormattedUsers] = React.useState([]);

  const getAllManufacturerUsers = React.useCallback(async () => {
    if (manufacturerData && manufacturerData?.ID) {
      const apiServe = new APIService();
      const response = await apiServe.getDataFromBackend(
        `getmanufacturerusersbymanufacturer?ManufacturerID=${manufacturerData.ID}`
      );
      return response?.data?.data;
    }
    return [];
  }, [manufacturerData]);

  const refreshManufacturerUsers = React.useCallback(() => {
    getAllManufacturerUsers().then((data) => {
      setFormattedUsers(data?.length > 0 ? data : []);
    });
  }, [getAllManufacturerUsers]);

  React.useEffect(() => {
    refreshManufacturerUsers();
  }, [refreshManufacturerUsers, manufacturerData]);

  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <SectionHeader
        title="Manufacturer Users"
        showButton={false}
        rightContent={
          <ManufacturerUserAddAction
            manufacturerData={manufacturerData}
            canAddUser={canAddUser}
            onUserAdded={refreshManufacturerUsers}
            buttonStyle={{ marginBottom: 0, marginTop: 0 }}
          />
        }
      />
      <GenericDashboard data={formattedUsers} screen="ManufacturerUsers" />
    </div>
  );
};

export default ManufacturerUsers;
